import { Action, ApplicationAction } from './actions';
import { IApplication, IOpenApplications } from './state';

export function openApplications(
  state: IOpenApplications,
  action: Action,
): IOpenApplications {
  if (action.scope.parentType === 'openApplications') {
    switch (action.type) {
      default:
        return {
          ...state,
          [action.scope.id]: applicationReducer(
            state[action.scope.id],
            action as ApplicationAction,
          ),
        };
    }
  }

  return state;
}

/**
 * @deprecated
 */
function applicationReducer(
  state: IApplication,
  action: ApplicationAction,
): IApplication {
  switch (action.type) {
    case 'Set communication tab':
      return {
        ...state,
        communicationTab: action.payload,
      };
    default:
      throw new Error();
  }
}
